import React, { useContext } from 'react';
import { GlobalAppContext } from './App';
import CONSTANTS from 'src/utils/constants';
import { Badge, SpaceBetween } from '@amzn/awsui-components-react';

const PHOTO_URL = 'https://badgephotos.corp.amazon.com/?uid=';

export default function AppHeader() {
    const { userProfile } = useContext(GlobalAppContext);

    const getRole = (roles: string[] | undefined) => {
        return roles != undefined ? `(${roles.join(', ')})` : '';
    }

    return <div id="header" className="top-navigation-container">
        <ul className="menu-list">
        <li>
            <img className="application-icon" src={CONSTANTS.IMAGE_PATH + 'amazon-logo.svg'} />
        </li>
        <li className="margin-auto">
            <SpaceBetween size="xs" direction="horizontal">
                <span>ATP</span>
                {CONSTANTS.ENVIRONMENT_VARIABLES.TPE_UI_STAGE !== "prod" ? <Badge color="blue">{CONSTANTS.ENVIRONMENT_VARIABLES.TPE_UI_STAGE}</Badge> : null}
            </SpaceBetween>
        </li>
        <li className="username">
                <div className="account"><img className="profile" src={PHOTO_URL + userProfile?.user} /></div>
                {userProfile?.firstName} {userProfile?.lastName} {getRole(userProfile?.roles)}
        </li>
        </ul>
    </div>
}
